import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgJhipsterModule } from 'ng-jhipster';

import { ScreensDemoSharedModule } from './shared';
import { ScreensDemoCoreModule } from './core';
import { ScreensDemoAppRoutingModule } from './mras-app-routing.module';
import { ScreensInterviewModule } from './interview/screens-interview.module';
import * as moment from 'moment';
import { JhiMainComponent, ErrorComponent } from './layouts';
import { SharedModule } from '@Shared/shared.module';

@NgModule({
    imports: [
        BrowserModule,
        NgJhipsterModule.forRoot({
            // set below to true to make alerts look like toast
            alertAsToast: false,
            alertTimeout: 5000,
            i18nEnabled: true,
            defaultI18nLang: 'en'
        }),
        ScreensDemoSharedModule.forRoot(),
        ScreensDemoCoreModule,
        ScreensInterviewModule,
        ScreensDemoAppRoutingModule,
        SharedModule
    ],
    declarations: [JhiMainComponent, ErrorComponent],
    providers: [
    ],
    bootstrap: [JhiMainComponent],
    exports: [ScreensInterviewModule]
})
export class MrasAppModule {
    constructor(private dpConfig: NgbDatepickerConfig) {
        this.dpConfig.minDate = { year: moment().year() - 100, month: 1, day: 1 };
    }
}
